import localForage from 'localforage';
export default {
    install(app) {
        app.config.globalProperties.$localforage = localForage;
    }
};